export const AP = "Account Payable";
export const AR = "Account Receivable";
export const CASHFLOW = "Cashflow";
export const APURL = "account-payable";
export const ARURL = "account-receivable";
export const CASHFLOWURL = "cashflow";